export const PROJECT_INTERACTIONS = 'Project Interactions';
export const ARTICLE_INTERACTIONS = 'Article Interactions';
export const ARTICLE_SEARCH = 'Article Search';
export const GDPR_POPUP_MESSAGE = 'GDPR';
export const INTERNAL = 'Internal';
export const USER = 'User';
export const WEB_VITALS = 'Web Vitals';
export const NAVIGATION_ITEM_CLICK = 'Tab Interactions';
export const DD_LISTING_INTERACTIONS = 'DD Listing Interactions';
